import React, {useState, useEffect} from "react"
import {FunctionComponent} from "react"

interface DescriptionCardProps {
	description: string
	title: string
}

const DescriptionCard: FunctionComponent<DescriptionCardProps> = ({title, description}: DescriptionCardProps) => {

	return (
		<section className='description-card'>
			<div className='description-card--title'>{title}</div>
			<div className='description-card--paragraph'>{description}</div>
		</section>
	)
}

export default DescriptionCard
